// 这里编写全局注册的filter
import Vue from "vue";
import { isNull} from "@/utils";

// 千分位分隔符表示价格
// 123456 => 123,456
function formatPrice(val) {
  if (isNull(val) || isNaN(val)) return;
  let USPrice = Number.parseFloat(val).toLocaleString("en-US");

  // 完全是整数, 需要添加小数点
  if (USPrice.toString().indexOf(".") === -1) USPrice += ".00";

  return "¥" + USPrice;
}

function phone(mobile = "") {
  return (
    mobile.toString().substring(0, 3) + "****" + mobile.toString().substring(7)
  );
}

const filters = {
  formatPrice,
  phone
};

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
export default filters;



// WEBPACK FOOTER //
// ./src/utils/filter.js